import { Component } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-vendor-change-password',
  templateUrl: './vendor-change-password.component.html',
  styleUrls: ['./vendor-change-password.component.scss'],
})
export class VendorChangePasswordComponent {
  form: FormGroup;
  loading = false;
  showPassword = false;
  showConfirmPassword = false;
  success = false;
  errorMsg = '';
  token: string | null;
  email: string | null = null;

  private vendorBaseUri = environment.vendorBaseUri;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.token = this.route.snapshot.paramMap.get('token');

    if (this.token) {
      try {
        this.email = atob(this.token);
      } catch {
        this.email = null;
      }
    }

    this.form = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(6), this.passwordStrengthValidator]],
        confirmPassword: ['', Validators.required],
      },
      { validator: this.matchPasswords }
    );
  }

  matchPasswords(form: FormGroup) {
    return form.get('password')?.value === form.get('confirmPassword')?.value
      ? null
      : { mismatch: true };
  }

  // ─── Password strength ───

  passwordStrengthValidator(control: AbstractControl): ValidationErrors | null {
    const val = control.value || '';
    if (!val) return null;
    const errors: any = {};
    if (!/[A-Z]/.test(val)) errors.noUppercase = true;
    if (!/[0-9]/.test(val)) errors.noNumber = true;
    return Object.keys(errors).length ? errors : null;
  }

  get passwordRules() {
    const val = this.form?.get('password')?.value || '';
    return [
      { label: 'At least 6 characters', met: val.length >= 6 },
      { label: 'One uppercase letter (A-Z)', met: /[A-Z]/.test(val) },
      { label: 'One number (0-9)', met: /[0-9]/.test(val) },
    ];
  }

  get showPasswordRules(): boolean {
    const ctrl = this.form?.get('password');
    return !!ctrl?.value && ctrl.value.length > 0;
  }

  get isInvalidToken(): boolean {
    return !this.token || !this.email;
  }

  onSubmit(): void {
    if (this.form.invalid || !this.token) return;

    this.loading = true;
    this.errorMsg = '';

    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' });
    const payload = {
      email: this.token,
      new_pass: this.form.value.password,
      confirm_pass: this.form.value.confirmPassword,
    };

    this.http
      .post<any>(`${this.vendorBaseUri}/unauth/vendor/reset-password-update`, payload, { headers })
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          if (res?.statusCode === 200) {
            this.success = true;
          } else {
            this.errorMsg = res?.msg || 'Something went wrong. Please try again.';
          }
        },
        error: (err: any) => {
          this.loading = false;
          this.errorMsg = err?.error?.msg || 'Something went wrong. Please try again.';
        },
      });
  }

  goToLogin(): void {
    this.router.navigate(['/vendors/login']);
  }
}
